import React from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';

import style from './SizeSlider.module.scss';

const { fadeSlider } = style;

interface Props {
  sliderHeight: string;

  percentage: number;

  onChange: (value: number) => void;

  onSliderRelease: (value: number) => void;
}

const StyledSlider = withStyles({
  root: {
    color: '#fff',
  },
  thumb: {
    height: 18,
    width: 18,
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
    /**
     * Fade the slider glow in and out
     */
    animation: `${fadeSlider} 4s`,
  },
  vertical: {
    '& $rail': {
      width: 8,
    },
    '& $track': {
      width: 8,
    },
  },
})(Slider);

/**
 * In order to get a smoother scaling effect from the slider, we multiply the slider values by a
 * certain factor (10). This makes a 5-100% size slider into a 50-1000% slider, giving us 950 points
 * on the slider.
 */
const MULTIPLICATION_FACTOR = 10;

/**
 * Because of the above, we use the functions below to transform the percentage coming in and going out.
 */
const scaleDownPercentage = (value: number) => value / MULTIPLICATION_FACTOR;
const scaleUpPercentage = (value: number) => value * MULTIPLICATION_FACTOR;

const SizeSlider = ({
  sliderHeight, percentage, onChange, onSliderRelease,
}: Props): React.ReactElement => (
  <div style={{ height: sliderHeight }}>
    <StyledSlider
      orientation="vertical"
      onChange={(event, newValue) => {
        const sliderValue = Array.isArray(newValue) ? newValue[0] : newValue;

        onChange(scaleDownPercentage(sliderValue));
      }}
      onChangeCommitted={(event, newValue) => {
        const sliderValue = Array.isArray(newValue) ? newValue[0] : newValue;

        onSliderRelease(scaleDownPercentage(sliderValue));
      }}
      defaultValue={500}
      value={scaleUpPercentage(percentage)}
      min={50}
      max={1000}
      aria-labelledby="vertical-slider"
    />
  </div>
);

export default SizeSlider;
